<div class="header d-flex justify-content-space-between align-items-center px-plus py-small pt-medium">
  <span class="header-title st-6">ویرایش کارت</span>
</div>
<div
  *ngIf="form"
  class="form pt-plus px-plus group-list-item"
  [formGroup]="form"
>
  <ui-form-field
    class="alias-field"
    label="نام کارت"
    [maxSize]="15"
    [formControlName]="'alias'"
    [hasCleaner]="true"
  ></ui-form-field>

  <div class="expiration-field mt-plus">
    <ui-form-field
      *ngIf="type === 'source'"
      class="alias-field"
      label="تاریخ انقضا"
      [formControlName]="'expireDate'"
      [maxSize]="40"
      (keydown)="expirationDateKeydown($event)"
    ></ui-form-field>
    <span
      class="overlay"
      (click)="expirationDateClick()"
    ></span>
  </div>
</div>
<div class="actions mt-mega pb-plus">
  <common-ui-components-temp-ngx-button
    class="cancel"
    [style]="'tinted-on-elevated'"
    [size]="'medium'"
    (clickHandler)="close()"
  >
    انصراف
  </common-ui-components-temp-ngx-button>
  <common-ui-components-temp-ngx-button
    class="save"
    [disabled]="form.invalid || form.pristine"
    [size]="'medium'"
    [fullWidth]="true"
    (clickHandler)="save()"
  >
    ذخیره تغییرات
  </common-ui-components-temp-ngx-button>
</div>
<daily-bank-card-date-picker
  [date]="form.value?.expireDate"
  (confirm)="confirmDateSelection($event)"
  (hide)="hideDatePicker()"
  *ngIf="displayingDatePicker"
></daily-bank-card-date-picker>
